import { NavigationItem } from "./NavigationItem";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { UserItem } from "../../HTML/Navigation/UserItem";
import { toMap } from "../../../../HA";

export class NavigationUser extends NavigationItem {

    public updateUser(data: Map<any, any>) {
        if (data.has("picture")) {
            this.getTag().updateImage(toMap({src: data.get("picture")}));
            if (data.get("picture") !== "/file/ha/svg/user") {
                this.getTag().isConnected();
            } else {
                this.getTag().disconnected();
            }
        }
    }

    protected subscribeToUser() {
        this.getUserService().subscribe((data: Map<any, any>) => {
            this.updateUser(data);
        });
    }

    protected getUserService(): any {
        return this.getService("ha.service.user");
    }

    /**
     * @param data
     */
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        this.subscribeToUser();
    }

    protected createTag(data: any) {
        this.addToData("tag", new UserItem(data));
    }
}

ControllerRegistry.register("NavigationUser", NavigationUser);
